import React from 'react';
import { Field } from 'formik';
import { salutationOptions } from '../../store';
import Section from '../form/Section';
import Dropdown from '../form/Dropdown';
import TextInput from '../form/TextInput';
import TextArea from '../form/TextArea';

const BillingInformation = ({ values }) => {
  return (
    <Section title='Billing Contact Information'>
      <div className='flex mb-2 flex-col md:flex-row'>
        <div className='w-full mr-0 md:w-1/2 md:mr-3'>
          <Field
            label='Salutation'
            name='billing_contact_salutation'
            value={values.billing_contact_salutation}
            required
            options={salutationOptions}
            component={Dropdown}
          />
        </div>
        <div className='w-1/2 ml-3'></div>
      </div>
      {/* --- */}
      <div className='flex mb-2 flex-col md:flex-row'>
        <div className='w-full mr-0 md:w-1/2 md:mr-3'>
          <Field
            label='First Name'
            name='billing_contact_first_name'
            value={values.billing_contact_first_name}
            required
            component={TextInput}
          />
        </div>
        <div className='w-full ml-0 md:w-1/2 md:ml-3'>
          <Field
            label='Last Name'
            name='billing_contact_last_name'
            value={values.billing_contact_last_name}
            required
            component={TextInput}
          />
        </div>
      </div>
      {/* --- */}
      <div className='flex mb-2 flex-col md:flex-row'>
        <div className='w-full mr-0 md:w-1/2 md:mr-3'>
          <Field
            label='Company Legal Entity Name'
            name='billing_contact_company'
            value={values.billing_contact_company}
            required
            component={TextInput}
          />
        </div>
        <div className='w-full ml-0 md:w-1/2 md:ml-3'>
          <Field
            label='Job Title'
            name='billing_contact_job_title'
            value={values.billing_contact_job_title}
            required
            component={TextInput}
          />
        </div>
      </div>
      {/* --- */}
      <div className='flex mb-2 flex-col md:flex-row'>
        <div className='w-full mr-0 md:w-1/2 md:mr-3'>
          <Field
            label='Email'
            name='billing_contact_email'
            value={values.billing_contact_email}
            type='email'
            required
            component={TextInput}
          />
        </div>
        <div className='w-full ml-0 md:w-1/2 md:ml-3'>
          <Field
            label='Contact No.'
            name='billing_contact_no'
            value={values.billing_contact_no}
            required
            component={TextInput}
          />
        </div>
      </div>
      <div className='mb-2'>
        <Field
          label='Billing Address'
          name='billing_address'
          value={values.billing_address}
          required
          component={TextArea}
        />
      </div>
    </Section>
  );
};

export default BillingInformation;
